<head>
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">
</head>

<div *ngIf="checkConnectionStatus" class="noInternet">
    <p style="font-size: 18px;font-weight: 600;"><i class="fa fa-frown-o" aria-hidden="true"></i> Oops!</p>
    <p><img style="margin-top: -5px;width: 2%;"  src="assets/noInternet.png"> Currently You are Offline. Internet Connection is required</p>
</div>

<router-outlet></router-outlet>